import axios from "axios";
import { db, auth } from "app/firebaseInit";
import { collection, doc, getDoc, getDocs, query, Timestamp, where } from "firebase/firestore";
import LogService from "./LogService.ts";

const COLLECTION_NAME = 'contents';
const CONTENT_DETAILS_COLLECTION = "contentDetails";

export const hasPublishedContent = async (categoryId) => {
    const contentsRef = collection(db, COLLECTION_NAME);
    const q = query(contentsRef, where("category", "==", categoryId), where("state", "==", "Published"));
    const querySnapshot = await getDocs(q);

    return !querySnapshot.empty; // Eğer en az 1 tane yayınlanmış içerik varsa true döner
};

// Kategoriye bağlı içerik var mı kontrol eden fonksiyon
export const hasContent = async (categoryId) => {
    const contentsRef = collection(db, COLLECTION_NAME);
    const q = query(contentsRef, where("category", "==", categoryId));
    const querySnapshot = await getDocs(q);

    return !querySnapshot.empty; // Eğer en az 1 içerik varsa true döner
};

// ✅ Meilisearch üzerinden içerik arama fonksiyonu

export const searchContents = async ({ queryText = "", page = 1, limit = 10, filters = "", sort }) => {
    try {

        const invalidStatuses = ["in_progress", "uploaded",
            "cancelled", "error", "archived"];
        const cutoff = Timestamp.fromMillis(
            Date.now() - 12 * 60 * 60 * 1000 // 12 saat önce
        );

        const q = query(
            collection(db, "uploads"),
            where("status", "in", invalidStatuses),
            where("createdAt", "<=", cutoff)
        );

        const snapshot = await getDocs(q);
        if (snapshot.empty) {
            console.log("No uploads to cleanup.");
        } else {
            snapshot.forEach((doc) => {
                console.log(doc.id, "=>", doc.data());
            });
        }

        const HOST_URL = process.env.REACT_APP_MEILISEARCH_HOST;
        const idToken = await auth.currentUser.getIdToken();
        const response = await axios.get(`${HOST_URL}/search/search-admin`, {
            params: {
                query: queryText,
                sort: sort,
                // lang: 'en',
                page,
                limit,
                filters: filters || undefined  // boşsa parametreye eklenmez
            },
            headers: {
                'Authorization': `Bearer ${idToken}`,
                'Content-Type': 'application/json',
            }
        });

        return {
            hits: response.data.hits,
            total: response.data.estimatedTotalHits
        };
    } catch (error) {
        console.error("Meilisearch search error:", error);
        await LogService.addErrorLog("searchContents error", error, { queryText, page, limit, filters });
        return { hits: [], total: 0 };
    }
};

// ✅ İçerik detaylarını id’ye göre getir
const fetchContentDetails = async (id) => {
    const q = query(
        collection(db, CONTENT_DETAILS_COLLECTION),
        where("contentId", "==", id)
    );
    const querySnapshot = await getDocs(q);

    let result = {
        descriptions: {},
        mediaURLs: {},
        subtitles: {}
    };

    if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            result.descriptions[data.lang] = data.description;
            result.mediaURLs[data.lang] = data.mediaUrl;
            result.subtitles[data.lang] = data.subTitle;
        });
    } else {
        console.log("No matching documents found.");
    }

    return result;
};

export const fetchContentFromFirestore = async (contentId) => {
    const docRef = doc(db, "contents", contentId); // contents senin collection adın
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) return null;

    const contentData = docSnap.data();
    const details = await fetchContentDetails(contentId); // descriptions, mediaURLs, subtitles

    return { ...contentData, details };
};
